import request from '@/utils/seftRequest';

// 校验订户可否重装
export function reconnectionCheckBsnl(data) {
  return request('/ding/subsService/reconnectionCheckBsnl', {
    method: 'POST',
    body: data,
  });
}

// 查询可用套餐
export function qryAvailablePlanListBsnl(data) {
  return request('/ding/subsService/qryAvailablePlanListBsnl', {
    method: 'POST',
    body: data,
  });
}

// 重装
export function reconnectionBsnl(data) {
  return request('/ding/subsService/reconnectionBsnl', {
    method: 'POST',
    body: data,
  });
}
